import { IAddUpdateBannerRequest } from "../../../model/admin-portal/request/add-update-banner-request";
import { IAddUpdateCategoryNewsRequest } from "../../../model/admin-portal/request/add-update-category-news-request";
import { IAddUpdateGovernamentalStrucutreRequest } from "../../../model/admin-portal/request/add-update-governamental-strucutre-request";
import { IAddUpdateLinkServiceRequest } from "../../../model/admin-portal/request/add-update-link-service-request";
import { IAddUpdateNewRequest } from "../../../model/admin-portal/request/add-update-news-request";
import { IAddUpdateCustomPageRequest } from "../../../model/admin-portal/request/add-update-custom-page-request";
import { ITermPaggedRequest } from "../../../model/admin-portal/request/term-pagged-request";
import { IBasePagedRequest } from "../../../model/base/request/base-paged-request";
import { ICustomPagesListRequest } from "../../../model/admin-portal/request/custom-pages-list-request";
import { IBannersListResponse } from "../../../model/admin-portal/response/banners-list-response";
import { ICategoriesNewsListResponse } from "../../../model/admin-portal/response/categories-news-list-response";
import { IGovernamentalStructureReponse } from "../../../model/admin-portal/response/governamental-strutucture-response";
import { ILinkServicesListResponse } from "../../../model/admin-portal/response/link-services-list-response";
import { INewsListRespomse } from "../../../model/admin-portal/response/news-list-response";
import { ICustomPageListResponse } from "../../../model/admin-portal/response/custom-page-list-response";
import { IAddUpdateLicitacaoRequest } from "../../../model/admin-portal/request/add-update-licitacao-request";
import { ILicitacaoResponse } from "../../../model/admin-portal/response/licitacao-response";
import { IOrgaoResponse } from "../../../model/admin-portal/response/orgao-response";
import { IModalidadeLicitacaoResponse } from "../../../model/admin-portal/response/modalidade-licitacao-response";
import { IFaseLicitacaoResponse } from "../../../model/admin-portal/response/fase-licitacao-response";
import { ISituacaoLicitacaoResponse } from "../../../model/admin-portal/response/situacao-licitacao-response";
import { IAddUpdateConvenioRequest } from "../../../model/admin-portal/request/add-update-convenio-request";
import { IConvenioResponse } from "../../../model/admin-portal/response/convenio-response";
import { ISituacaoConvenioResponse } from "../../../model/admin-portal/response/situacao-convenio-response";
import { IAddUpdateEmendaParlamentarRequest } from "../../../model/admin-portal/request/add-update-emenda-parlamentar-request";
import { IEmendaParlamentarResponse } from "../../../model/admin-portal/response/emenda-parlamentar-response";
import { ITipoEmendaResponse } from "../../../model/admin-portal/response/tipo-emenda-response";
import { IFormaRepasseEmendaResponse } from "../../../model/admin-portal/response/forma-repasse-emenda-response";
import { IFuncaoGovernoResponse } from "../../../model/admin-portal/response/funcao-governo-response";
import { IConvenioLookupResponse } from "../../../model/admin-portal/response/convenio-lookup-response";
import { IAddUpdatePrestacaoContasRequest } from "../../../model/admin-portal/request/add-update-prestacao-contas-request";
import { IPrestacaoContasResponse } from "../../../model/admin-portal/response/prestacao-contas-response";
import { ITipoDocumentoPrestacaoContasResponse } from "../../../model/admin-portal/response/tipo-documento-prestacao-contas-response";
import { IAddUpdateDocumentoSetorialRequest } from "../../../model/admin-portal/request/add-update-documento-setorial-request";
import { IDocumentoSetorialResponse } from "../../../model/admin-portal/response/documento-setorial-response";
import { ITipoDocumentoSetorialResponse } from "../../../model/admin-portal/response/tipo-documento-setorial-response";
import { IAreaTransparenciaSetorialResponse } from "../../../model/admin-portal/response/area-transparencia-setorial-response";
import { IAddUpdateRepasseSetorialRequest } from "../../../model/admin-portal/request/add-update-repasse-setorial-request";
import { IRepasseSetorialResponse } from "../../../model/admin-portal/response/repasse-setorial-response";
import { IOrigemRepasseSetorialResponse } from "../../../model/admin-portal/response/origem-repasse-setorial-response";
import { IAddUpdateConselhoRequest } from "../../../model/admin-portal/request/add-update-conselho-request";
import { IConselhoResponse } from "../../../model/admin-portal/response/conselho-response";
import { IAddUpdateEstoqueMedicamentoRequest } from "../../../model/admin-portal/request/add-update-estoque-medicamento-request";
import { IEstoqueMedicamentoResponse } from "../../../model/admin-portal/response/estoque-medicamento-response";
import { IAddUpdateFilaEsperaRequest } from "../../../model/admin-portal/request/add-update-fila-espera-request";
import { IFilaEsperaResponse } from "../../../model/admin-portal/response/fila-espera-response";
import { ITipoFilaEsperaResponse } from "../../../model/admin-portal/response/tipo-fila-espera-response";
import { IAddUpdateContratoRequest } from "../../../model/admin-portal/request/add-update-contrato-request";
import { IContratoResponse } from "../../../model/admin-portal/response/contrato-response";
import { ITipoContratoResponse } from "../../../model/admin-portal/response/tipo-contrato-response";
import { ISituacaoContratoResponse } from "../../../model/admin-portal/response/situacao-contrato-response";
import { ILicitacaoLookupResponse } from "../../../model/admin-portal/response/licitacao-lookup-response";
import { IFornecedorLookupResponse } from "../../../model/admin-portal/response/fornecedor-lookup-response";
import { IAddUpdateObraRequest } from "../../../model/admin-portal/request/add-update-obra-request";
import { IObraResponse } from "../../../model/admin-portal/response/obra-response";
import { ISituacaoObraResponse } from "../../../model/admin-portal/response/situacao-obra-response";
import { IFuncaoObraResponse } from "../../../model/admin-portal/response/funcao-obra-response";
import { ITipoObraResponse } from "../../../model/admin-portal/response/tipo-obra-response";
import { IContratoLookupResponse } from "../../../model/admin-portal/response/contrato-lookup-response";
import { IFornecedorResponse } from "../../../model/admin-portal/response/fornecedor-response";
import { IServidorResponse } from "../../../model/admin-portal/response/servidor-response";
import { IFonteRecursoResponse } from "../../../model/admin-portal/response/fonte-recurso-response";
import { IFotoObraResponse } from "../../../model/admin-portal/response/foto-obra-response";
import { IAddUpdateFotoObraRequest } from "../../../model/admin-portal/request/add-update-foto-obra-request";
import { PaginationResponse } from "../../../model/base/response/pagination-response";
import HttpClient from "../../services/http-client";
import ApplicationAppService from "../application-app-service";
import { serialize } from "object-to-formdata";
const defaultPath = 'Admin';

let applicationData = ApplicationAppService.getApplicationData();

var baseUrl = applicationData.municipalPortalUrl;


const listBanners = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IBannersListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Banners`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IBannersListResponse>(), response.data));
};

const addUpdateBanner = async (params: IAddUpdateBannerRequest, file: File | null) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    if (file !== null)
        formData.append("file", file);

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/Banner`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};
const addUpdateNews = async (params: IAddUpdateNewRequest, file: File | null) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });
    if (file !== null)
        formData.append("file", file);

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/News`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const addUpdateGovernamentalStrucuture = async (params: IAddUpdateGovernamentalStrucutreRequest, file: File | null) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    if (file !== null)
        formData.append("image", file);

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/GovernamentalStructure`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const addUpdateCategoryNews = async (params: IAddUpdateCategoryNewsRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/CategoryNews`
    });
};

const addUpdateServiceLinks = async (params: IAddUpdateLinkServiceRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/ServiceLink`
    });
};


const listNews = async (requst: ITermPaggedRequest): Promise<PaginationResponse<INewsListRespomse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/News`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<INewsListRespomse>(), response.data));
};

const listGovernamentalSctructure = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IGovernamentalStructureReponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/GovernamentalStructure`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IGovernamentalStructureReponse>(), response.data));
};

const listServiceLinks = async (requst: ITermPaggedRequest): Promise<PaginationResponse<ILinkServicesListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/ServiceLinks`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<ILinkServicesListResponse>(), response.data));
};


const listCategoryNews = async (requst: ITermPaggedRequest): Promise<PaginationResponse<ICategoriesNewsListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/CategoriesNews`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<ICategoriesNewsListResponse>(), response.data));
};


const getBanners = async (id: number): Promise<IBannersListResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Banners/${id}`
    }).then((response) => Object.assign({} as IBannersListResponse, response.data));
};

const getGovernamentalStrucutre = async (id: number): Promise<IGovernamentalStructureReponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/GovernamentalStructure/${id}`
    }).then((response) => Object.assign({} as IGovernamentalStructureReponse, response.data));
};


const getNews = async (id: number): Promise<INewsListRespomse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/News/${id}`,

    }).then((response) => Object.assign({} as INewsListRespomse, response.data));
};


const getServiceLink = async (id: number): Promise<ILinkServicesListResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/ServiceLinks/${id}`,
    }).then((response) => Object.assign({} as ILinkServicesListResponse, response.data));
};


const getCategoryNews = async (id: number): Promise<ICategoriesNewsListResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/CategoriesNews/${id}`
    }).then((response) => Object.assign({} as ICategoriesNewsListResponse, response.data));
};



const deleteBanners = async (id: number): Promise<IBannersListResponse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/Banners/${id}`
    }).then((response) => Object.assign({} as IBannersListResponse, response.data));
};

const deleteNews = async (id: number): Promise<INewsListRespomse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/News/${id}`,

    }).then((response) => Object.assign({} as INewsListRespomse, response.data));
};


const deleteServiceLinks = async (id: number): Promise<ILinkServicesListResponse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/ServiceLinks/${id}`,
    }).then((response) => Object.assign({} as ILinkServicesListResponse, response.data));
};


const deleteCategoryNews = async (id: number): Promise<ICategoriesNewsListResponse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/CategoriesNews/${id}`
    }).then((response) => Object.assign({} as ICategoriesNewsListResponse, response.data));
};

const deleteGovernamentalStructure = async (id: number): Promise<ICategoriesNewsListResponse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/GovernamentalStructure/${id}`
    }).then((response) => Object.assign({} as ICategoriesNewsListResponse, response.data));
};

// Custom Pages
const listCustomPages = async (request: ICustomPagesListRequest): Promise<PaginationResponse<ICustomPageListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/CustomPages`,
        params: request
    }).then((response) => Object.assign(new PaginationResponse<ICustomPageListResponse>(), response.data));
};

const getCustomPage = async (id: number): Promise<ICustomPageListResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/CustomPages/${id}`
    }).then((response) => Object.assign({} as ICustomPageListResponse, response.data));
};

const addUpdateCustomPage = async (params: IAddUpdateCustomPageRequest) => {
    const formData = new FormData();

    // Campos básicos da página
    if (params.id !== null && params.id !== undefined) {
        formData.append('Id', params.id.toString());
    }
    formData.append('Title', params.title || '');
    formData.append('MetaDescription', params.metaDescription || '');
    formData.append('MetaKeywords', params.metaKeywords || '');
    formData.append('PublicationDate', params.publicationDate.toISOString());
    formData.append('Published', params.published.toString());
    if (params.order !== null && params.order !== undefined) {
        formData.append('Order', params.order.toString());
    }

    // Serializar sections com índices
    if (params.sections && params.sections.length > 0) {
        params.sections.forEach((section, sIdx) => {
            // Campos da seção
            if (section.id !== null && section.id !== undefined) {
                formData.append(`Sections[${sIdx}].Id`, section.id.toString());
            }
            formData.append(`Sections[${sIdx}].Type`, section.type.toString());
            formData.append(`Sections[${sIdx}].Title`, section.title || '');
            formData.append(`Sections[${sIdx}].Content`, section.content || '');
            formData.append(`Sections[${sIdx}].Url`, section.url || '');
            formData.append(`Sections[${sIdx}].ImageFileName`, section.imageFileName || '');
            formData.append(`Sections[${sIdx}].Order`, section.order.toString());

            // Arquivo da seção
            if (section.file) {
                formData.append(`Sections[${sIdx}].File`, section.file);
            }

            // Items da seção
            if (section.items && section.items.length > 0) {
                section.items.forEach((item, iIdx) => {
                    if (item.id !== null && item.id !== undefined) {
                        formData.append(`Sections[${sIdx}].Items[${iIdx}].Id`, item.id.toString());
                    }
                    formData.append(`Sections[${sIdx}].Items[${iIdx}].Title`, item.title || '');
                    formData.append(`Sections[${sIdx}].Items[${iIdx}].Subtitle`, item.subtitle || '');
                    formData.append(`Sections[${sIdx}].Items[${iIdx}].Description`, item.description || '');
                    formData.append(`Sections[${sIdx}].Items[${iIdx}].Url`, item.url || '');
                    formData.append(`Sections[${sIdx}].Items[${iIdx}].ImageFileName`, item.imageFileName || '');
                    formData.append(`Sections[${sIdx}].Items[${iIdx}].Order`, item.order.toString());

                    // Arquivo do item
                    if (item.file) {
                        formData.append(`Sections[${sIdx}].Items[${iIdx}].File`, item.file);
                    }
                });
            }
        });
    }

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/CustomPage`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const deleteCustomPage = async (id: number): Promise<void> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/CustomPages/${id}`
    }).then((response) => response.data);
};

const listAllCustomPages = async (published?: boolean): Promise<ICustomPageListResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/CustomPages/All`,
        params: { Published: published }
    }).then((response) => response.data);
};

// ==================== MENUS ====================

const listMenus = async () => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Menus`
    }).then((response) => {
        // O endpoint retorna PagedCollection com structure { items: [], page, pageSize, totalCount }
        return response.data?.items || response.data || [];
    });
};

const getMenu = async (id: number) => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Menus/${id}`
    }).then((response) => response.data);
};

const addUpdateMenu = async (params: any) => {
    const formData = new FormData();

    // Campos básicos do menu
    if (params.id !== null && params.id !== undefined) {
        formData.append('Id', params.id.toString());
    }
    formData.append('Title', params.title || '');
    formData.append('Order', params.order.toString());
    formData.append('Visible', params.visible.toString());

    // Vinculação do menu (página customizada ou URL externa)
    if (params.customPageId !== null && params.customPageId !== undefined) {
        formData.append('CustomPageId', params.customPageId.toString());
    }
    if (params.externalUrl) {
        formData.append('ExternalUrl', params.externalUrl);
    }

    // Items do menu
    if (params.items && params.items.length > 0) {
        params.items.forEach((item: any, idx: number) => {
            if (item.id !== null && item.id !== undefined) {
                formData.append(`Items[${idx}].Id`, item.id.toString());
            }
            formData.append(`Items[${idx}].Title`, item.title || '');
            if (item.customPageId !== null && item.customPageId !== undefined) {
                formData.append(`Items[${idx}].CustomPageId`, item.customPageId.toString());
            }
            if (item.externalUrl) {
                formData.append(`Items[${idx}].ExternalUrl`, item.externalUrl);
            }
            formData.append(`Items[${idx}].Order`, item.order.toString());
            formData.append(`Items[${idx}].Visible`, item.visible.toString());
        });
    }

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/Menu`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const deleteMenu = async (id: number): Promise<void> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/Menus/${id}`
    }).then((response) => response.data);
};

const reorderMenus = async (menuIds: number[]): Promise<void> => {
    return await HttpClient.executeRequest({
        method: 'patch',
        baseURL: baseUrl,
        url: `/${defaultPath}/Menus/Reorder`,
        data: { MenuIds: menuIds }
    }).then((response) => response.data);
};

const reorderMenuItems = async (menuItemIds: number[]): Promise<void> => {
    return await HttpClient.executeRequest({
        method: 'patch',
        baseURL: baseUrl,
        url: `/${defaultPath}/MenuItems/Reorder`,
        data: menuItemIds
    }).then((response) => response.data);
};

// ==================== LICITACAO ====================

const listLicitacoes = async (requst: ITermPaggedRequest): Promise<PaginationResponse<ILicitacaoResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Licitacoes`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<ILicitacaoResponse>(), response.data));
};

const getLicitacao = async (id: number): Promise<ILicitacaoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Licitacoes/${id}`
    }).then((response) => Object.assign({} as ILicitacaoResponse, response.data));
};

const addUpdateLicitacao = async (params: IAddUpdateLicitacaoRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/Licitacao`
    });
};

const listOrgaos = async (): Promise<IOrgaoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Orgaos`
    }).then((response) => response.data || []);
};

const listModalidadesLicitacao = async (): Promise<IModalidadeLicitacaoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/ModalidadesLicitacao`
    }).then((response) => response.data || []);
};

const listFasesLicitacao = async (): Promise<IFaseLicitacaoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/FasesLicitacao`
    }).then((response) => response.data || []);
};

const listSituacoesLicitacao = async (): Promise<ISituacaoLicitacaoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/SituacoesLicitacao`
    }).then((response) => response.data || []);
};

// ==================== CONVENIO ====================

const listConvenios = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IConvenioResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Convenios`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IConvenioResponse>(), response.data));
};

const getConvenio = async (id: number): Promise<IConvenioResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Convenios/${id}`
    }).then((response) => Object.assign({} as IConvenioResponse, response.data));
};

const addUpdateConvenio = async (params: IAddUpdateConvenioRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/Convenio`
    });
};

const listSituacoesConvenio = async (): Promise<ISituacaoConvenioResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/SituacoesConvenio`
    }).then((response) => response.data || []);
};

// ==================== EMENDA PARLAMENTAR ====================

const listEmendasParlamentares = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IEmendaParlamentarResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/EmendasParlamentares`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IEmendaParlamentarResponse>(), response.data));
};

const getEmendaParlamentar = async (id: number): Promise<IEmendaParlamentarResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/EmendasParlamentares/${id}`
    }).then((response) => Object.assign({} as IEmendaParlamentarResponse, response.data));
};

const addUpdateEmendaParlamentar = async (params: IAddUpdateEmendaParlamentarRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/EmendaParlamentar`
    });
};

const listTiposEmenda = async (): Promise<ITipoEmendaResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/TiposEmenda`
    }).then((response) => response.data || []);
};

const listFormasRepasseEmenda = async (): Promise<IFormaRepasseEmendaResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/FormasRepasseEmenda`
    }).then((response) => response.data || []);
};

const listFuncoesGoverno = async (): Promise<IFuncaoGovernoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/FuncoesGoverno`
    }).then((response) => response.data || []);
};

const listConveniosLookup = async (): Promise<IConvenioLookupResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/ConveniosLookup`
    }).then((response) => response.data || []);
};

// ==================== PRESTACAO DE CONTAS ====================

const listPrestacoesContas = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IPrestacaoContasResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/PrestacoesContas`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IPrestacaoContasResponse>(), response.data));
};

const getPrestacaoContas = async (id: number): Promise<IPrestacaoContasResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/PrestacoesContas/${id}`
    }).then((response) => Object.assign({} as IPrestacaoContasResponse, response.data));
};

const addUpdatePrestacaoContas = async (params: IAddUpdatePrestacaoContasRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/PrestacaoContas`
    });
};

const listTiposDocumentoPrestacaoContas = async (): Promise<ITipoDocumentoPrestacaoContasResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/TiposDocumentoPrestacaoContas`
    }).then((response) => response.data || []);
};

// ==================== DOCUMENTO SETORIAL ====================

const listDocumentosSetoriais = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IDocumentoSetorialResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/DocumentosSetoriais`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IDocumentoSetorialResponse>(), response.data));
};

const getDocumentoSetorial = async (id: number): Promise<IDocumentoSetorialResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/DocumentosSetoriais/${id}`
    }).then((response) => Object.assign({} as IDocumentoSetorialResponse, response.data));
};

const addUpdateDocumentoSetorial = async (params: IAddUpdateDocumentoSetorialRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/DocumentoSetorial`
    });
};

const listTiposDocumentoSetorial = async (): Promise<ITipoDocumentoSetorialResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/TiposDocumentoSetorial`
    }).then((response) => response.data || []);
};

const listAreasTransparenciaSetorial = async (): Promise<IAreaTransparenciaSetorialResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/AreasTransparenciaSetorial`
    }).then((response) => response.data || []);
};

// ==================== REPASSE SETORIAL ====================

const listRepassesSetoriais = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IRepasseSetorialResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/RepassesSetoriais`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IRepasseSetorialResponse>(), response.data));
};

const getRepasseSetorial = async (id: number): Promise<IRepasseSetorialResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/RepassesSetoriais/${id}`
    }).then((response) => Object.assign({} as IRepasseSetorialResponse, response.data));
};

const addUpdateRepasseSetorial = async (params: IAddUpdateRepasseSetorialRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/RepasseSetorial`
    });
};

const listOrigensRepasseSetorial = async (): Promise<IOrigemRepasseSetorialResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/OrigensRepasseSetorial`
    }).then((response) => response.data || []);
};

// ==================== CONSELHO ====================

const listConselhos = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IConselhoResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Conselhos`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IConselhoResponse>(), response.data));
};

const getConselho = async (id: number): Promise<IConselhoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Conselhos/${id}`
    }).then((response) => Object.assign({} as IConselhoResponse, response.data));
};

const addUpdateConselho = async (params: IAddUpdateConselhoRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/Conselho`
    });
};

// ==================== ESTOQUE MEDICAMENTO ====================

const listEstoquesMedicamento = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IEstoqueMedicamentoResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/EstoquesMedicamento`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IEstoqueMedicamentoResponse>(), response.data));
};

const getEstoqueMedicamento = async (id: number): Promise<IEstoqueMedicamentoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/EstoquesMedicamento/${id}`
    }).then((response) => Object.assign({} as IEstoqueMedicamentoResponse, response.data));
};

const addUpdateEstoqueMedicamento = async (params: IAddUpdateEstoqueMedicamentoRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/EstoqueMedicamento`
    });
};

// ==================== FILA DE ESPERA ====================

const listFilasEspera = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IFilaEsperaResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/FilasEspera`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IFilaEsperaResponse>(), response.data));
};

const getFilaEspera = async (id: number): Promise<IFilaEsperaResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/FilasEspera/${id}`
    }).then((response) => Object.assign({} as IFilaEsperaResponse, response.data));
};

const addUpdateFilaEspera = async (params: IAddUpdateFilaEsperaRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/FilaEspera`
    });
};

const listTiposFilaEspera = async (): Promise<ITipoFilaEsperaResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/TiposFilaEspera`
    }).then((response) => response.data || []);
};

// ==================== CONTRATO ====================

const listContratos = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IContratoResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Contratos`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IContratoResponse>(), response.data));
};

const getContrato = async (id: number): Promise<IContratoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Contratos/${id}`
    }).then((response) => Object.assign({} as IContratoResponse, response.data));
};

const addUpdateContrato = async (params: IAddUpdateContratoRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/Contrato`
    });
};

const listTiposContrato = async (): Promise<ITipoContratoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/TiposContrato`
    }).then((response) => response.data || []);
};

const listSituacoesContrato = async (): Promise<ISituacaoContratoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/SituacoesContrato`
    }).then((response) => response.data || []);
};

const listLicitacoesLookup = async (): Promise<ILicitacaoLookupResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/LicitacoesLookup`
    }).then((response) => response.data || []);
};

const listFornecedoresLookup = async (): Promise<IFornecedorLookupResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/FornecedoresLookup`
    }).then((response) => response.data || []);
};

// ==================== OBRA ====================

const listObras = async (requst: IBasePagedRequest): Promise<PaginationResponse<IObraResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Obras`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IObraResponse>(), response.data));
};

const getObra = async (id: number): Promise<IObraResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Obras/${id}`
    }).then((response) => Object.assign({} as IObraResponse, response.data));
};

const addUpdateObra = async (params: IAddUpdateObraRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/Obra`
    });
};

const listSituacoesObra = async (): Promise<ISituacaoObraResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/SituacoesObra`
    }).then((response) => response.data || []);
};

const listFuncoesObra = async (): Promise<IFuncaoObraResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/FuncoesObra`
    }).then((response) => response.data || []);
};

const listTiposObra = async (): Promise<ITipoObraResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/TiposObra`
    }).then((response) => response.data || []);
};

const listContratosLookup = async (): Promise<IContratoLookupResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/ContratosLookup`
    }).then((response) => response.data || []);
};

// ==================== CADASTROS AUXILIARES (lookups editáveis) ====================

const addUpdateOrgao = async (params: any) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/Orgao`
    });
};

const listFornecedores = async (): Promise<IFornecedorResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Fornecedores`
    }).then((response) => response.data || []);
};

const addUpdateFornecedor = async (params: any) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/Fornecedor`
    });
};

const listServidores = async (): Promise<IServidorResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Servidores`
    }).then((response) => response.data || []);
};

const addUpdateServidor = async (params: any) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/Servidor`
    });
};

const addUpdateModalidadeLicitacao = async (params: any) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/ModalidadeLicitacao`
    });
};

const addUpdateFaseLicitacao = async (params: any) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/FaseLicitacao`
    });
};

const addUpdateTipoContrato = async (params: any) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/TipoContrato`
    });
};

const addUpdateFuncaoObra = async (params: any) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/FuncaoObra`
    });
};

const addUpdateTipoObra = async (params: any) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/TipoObra`
    });
};

const addUpdateTipoEmenda = async (params: any) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/TipoEmenda`
    });
};

const addUpdateFormaRepasseEmenda = async (params: any) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/FormaRepasseEmenda`
    });
};

const addUpdateFuncaoGoverno = async (params: any) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/FuncaoGoverno`
    });
};

const listFontesRecurso = async (): Promise<IFonteRecursoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/FontesRecurso`
    }).then((response) => response.data || []);
};

const addUpdateFonteRecurso = async (params: any) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/FonteRecurso`
    });
};

const listFotosObra = async (idObra: number): Promise<IFotoObraResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/FotosObra`,
        params: { idObra }
    }).then((response) => response.data || []);
};

const uploadDocumento = async (file: File): Promise<{ documentoUrl: string }> => {
    const formData = new FormData();
    formData.append("file", file);

    return await HttpClient.executeRequest({
        method: 'post',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/UploadDocumento`
    }).then((response) => response.data);
};

const addUpdateFotoObra = async (params: IAddUpdateFotoObraRequest, file: File | null) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });
    if (file !== null)
        formData.append("file", file);

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/FotoObra`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const AdminPortalAppService = {
    deleteGovernamentalStructure, addUpdateGovernamentalStrucuture, getGovernamentalStrucutre, listGovernamentalSctructure, deleteBanners, deleteNews, deleteCategoryNews, deleteServiceLinks, listBanners, listCategoryNews, addUpdateCategoryNews, addUpdateServiceLinks, addUpdateNews, listNews, listServiceLinks, getBanners, getCategoryNews, getServiceLink, getNews, addUpdateBanner,
    listCustomPages, getCustomPage, addUpdateCustomPage, deleteCustomPage, listAllCustomPages,
    listMenus, getMenu, addUpdateMenu, deleteMenu, reorderMenus, reorderMenuItems,
    listLicitacoes, getLicitacao, addUpdateLicitacao, listOrgaos, listModalidadesLicitacao, listFasesLicitacao, listSituacoesLicitacao,
    listConvenios, getConvenio, addUpdateConvenio, listSituacoesConvenio,
    listEmendasParlamentares, getEmendaParlamentar, addUpdateEmendaParlamentar, listTiposEmenda, listFormasRepasseEmenda, listFuncoesGoverno, listConveniosLookup,
    listPrestacoesContas, getPrestacaoContas, addUpdatePrestacaoContas, listTiposDocumentoPrestacaoContas,
    listDocumentosSetoriais, getDocumentoSetorial, addUpdateDocumentoSetorial, listTiposDocumentoSetorial, listAreasTransparenciaSetorial,
    listRepassesSetoriais, getRepasseSetorial, addUpdateRepasseSetorial, listOrigensRepasseSetorial,
    listConselhos, getConselho, addUpdateConselho,
    listEstoquesMedicamento, getEstoqueMedicamento, addUpdateEstoqueMedicamento,
    listFilasEspera, getFilaEspera, addUpdateFilaEspera, listTiposFilaEspera,
    listContratos, getContrato, addUpdateContrato, listTiposContrato, listSituacoesContrato, listLicitacoesLookup, listFornecedoresLookup,
    listObras, getObra, addUpdateObra, listSituacoesObra, listFuncoesObra, listTiposObra, listContratosLookup,
    addUpdateOrgao, listFornecedores, addUpdateFornecedor, listServidores, addUpdateServidor,
    addUpdateModalidadeLicitacao, addUpdateFaseLicitacao, addUpdateTipoContrato, addUpdateFuncaoObra, addUpdateTipoObra,
    addUpdateTipoEmenda, addUpdateFormaRepasseEmenda, addUpdateFuncaoGoverno, listFontesRecurso, addUpdateFonteRecurso,
    listFotosObra, addUpdateFotoObra, uploadDocumento
};

export default AdminPortalAppService